// Internal Imports
import BaseCommand from "./baseCommand";
import { DocumentUtils, AmplitudeUtils } from "../utils";
import { updateDocSignatories } from "../actions/DocumentActions/services";
import { EVENTS, DOCUMENTS } from "../constants";

// Destructuring
const { getSignatureConfigJson, convertSignersData } = DocumentUtils;
const { DOCUMENT_MODE } = DOCUMENTS;
const { amplitudeLogEvent } = AmplitudeUtils;

class AddSignBlockCommand extends BaseCommand {
  constructor(componentData) {
    super();
    this.componentData = componentData;
    this.preventNukeActiveState = true;
  }

  async execute() {
    const {
      mode,
      sectionDataForSignature,
      docId,
      signatories,
      updateDocSignatoriesAction,
      setState,
      signBlocks,
      onSectionUpdate,
    } = this.componentData;

    const newSignBlocks = [...signBlocks];

    this.componentData.insertIndex = signBlocks.length;
    const newSignerData = JSON.parse(
      JSON.stringify(...getSignatureConfigJson()),
    );
    delete newSignerData.errMsg;
    delete newSignerData.disabled;
    delete newSignerData.showNameField;
    delete newSignerData.updateProcess;
    delete newSignerData.notValid;
    const newSigner = convertSignersData([newSignerData]);
    newSigner[0].id =
      signBlocks.length > 0 ? signBlocks[signBlocks.length - 1].id + 1 : 1;
    if (mode === DOCUMENT_MODE.TEMPLATE) {
      newSignBlocks.push(newSigner[0]);
      await setState({
        signBlocks: newSignBlocks,
      });
      onSectionUpdate(newSigner[0], false, newSignBlocks);
      this.componentData.newSignBlocks = newSignBlocks;
    } else {
      const updatedSignerData = [
        {
          component_id: sectionDataForSignature.id,
          signers: [{ ...newSigner[0] }],
        },
      ];
      const signerData = await updateDocSignatories(updatedSignerData, docId);
      const updatedSignatories = JSON.parse(JSON.stringify(signatories));
      if (
        Array.isArray(signerData) &&
        signerData[0] &&
        Array.isArray(signerData[0].signers) &&
        signerData[0].signers.length > 0
      ) {
        updatedSignatories.forEach(signer => {
          if (signer.component_id === signerData[0].component_id) {
            let found = false;
            signer.signers.forEach((d, index) => {
              if (d.id === signerData[0].signers[0].id) {
                signer.signers[index] = { ...signerData[0].signers[0] };
                found = true;
              }
            });
            if (!found) {
              signer.signers.push(signerData[0].signers[0]);
            }
          }
        });
        updateDocSignatoriesAction(updatedSignatories);
        newSignBlocks.push(signerData[0].signers[0]);
        setState({
          signBlocks: newSignBlocks,
        });
        this.componentData.newSignBlocks = newSignBlocks;
      }
      this.componentData.updateActiveSignatureData(
        newSignBlocks,
        updatedSignatories,
        sectionDataForSignature.id,
      );
      amplitudeLogEvent(EVENTS.EVENT_NAMES.SIGNER_ADDED, {
        Signercount: Array.isArray(newSignBlocks) ? newSignBlocks.length : null,
        SignatureFieldsActive: ["signature"],
      });
    }
  }

  async undo() {
    const {
      mode,
      sectionDataForSignature,
      docId,
      signatories,
      setState,
      onSectionUpdate,
      deleteDocSignerSection,
    } = this.componentData;
    const signerIndex = this.componentData.insertIndex;
    const newSignBlocks = [...this.componentData.newSignBlocks];
    const signerConfigInfo = [];
    if (newSignBlocks) {
      newSignBlocks[signerIndex].signer_config.options.forEach(data => {
        if (data.checked) {
          signerConfigInfo.push(data.id);
        }
      });
    }

    const deleteSigner = [
      {
        component_id: sectionDataForSignature.id,
        ids: [newSignBlocks[signerIndex].id],
      },
    ];

    newSignBlocks.splice(signerIndex, 1);
    if (mode === DOCUMENT_MODE.DOCUMENT) {
      deleteDocSignerSection(deleteSigner, docId, newSignBlocks);

      const updatedSignatories = JSON.parse(JSON.stringify(signatories));
      updatedSignatories.forEach(signer => {
        if (signer.component_id === sectionDataForSignature.id) {
          signer.signers = newSignBlocks;
        }
      });
      this.componentData.updateActiveSignatureData(
        newSignBlocks,
        updatedSignatories,
        sectionDataForSignature.id,
      );
    }

    if (mode === DOCUMENT_MODE.TEMPLATE)
      onSectionUpdate([], false, newSignBlocks);
    setState({
      signBlocks: newSignBlocks,
    });
  }
}

export default AddSignBlockCommand;



// WEBPACK FOOTER //
// ./src/commands/addSignBlockCommand.js